import logo from './logo.svg';
import '../src/style/main.scss';
import '../src/style/common/common.scss';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import MeasurementSearch from './components/MeasurementSearch';
import Ner from './components/Ner';
import EntityExtractionFromImage from './components/EntityExtractionFromImage';
import EntityExtractionFromDesc from './components/EntityExtractionFromDesc';
import CompleteTheLook from './components/CompleteTheLook';
import Divider from './components/common/Divider';
import { Route, Routes } from "react-router-dom";
import Home from "./Home";
import VisualSearchLanding from './components/visualSearch/VisualSearchLanding';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route exact path="/vs" element={<VisualSearchLanding />} />
        <Route exact path="/" element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
